export const PATH = {
  HOME: '/',
  CHECK_VIHCLE: '/check-vihcle',
  INSURENCE_MOTO: '/insurence-motobike',
  INSURENCE_OBLIGATORY: '/insurence-obligatory',
  BOOKING: '/booking',
  BOOKING_PARTNER_IFRAME: '/booking-partner-iframe',
  RESET_PASSWORD: '/resetPassword',
  MY_BOOKING_HYSTORY: '/my-booking-history',
  BOOKING_HYSTORY: '/order-history',
  BOOKING_DETAIL: '/order-detail/:orderId',
  REFER_STATION: '/referStation'
}
